import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import DatePickerInput from './DatePicker';

function DatePickerDemo() {
  const initialDate = new Date();

  const handleDateChange = (date: Date) => {
    console.log(date);
  };

  return (
    <Container>
      <Container className="mt-10">
        <Row>
          <Col className="mt-10 p-0">
            <h4>Date Picker</h4>
            <Container className="d-flex justify-content-between flex-wrap p-0">
              <DatePickerInput
                placeholder={'Select a date'}
                label={'Sample label'}
                initialDate={initialDate}
                className="me-4"
                onChange={(date) => handleDateChange(date)}
              />
              <DatePickerInput
                placeholder={'Datepicker with Max date'}
                label={'Sample label'}
                initialDate={initialDate}
                className="me-4"
                onChange={(date) => handleDateChange(date)}
                maxDate={new Date("09-30-2022")}
              />
              <DatePickerInput
                placeholder={'Select a date'}
                label={'Sample label'}
                disabled
                className="me-4"
              />
              <DatePickerInput
                placeholder={'Select a date'}
                label={'Sample label'}
                isValid={true}
                className="me-4"
              />
              <DatePickerInput
                placeholder={'Select a date'}
                label={'Sample label'}
                isInvalid={true}
                className="me-4"
              />
            </Container>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default DatePickerDemo;
